import { render, staticRenderFns } from "./TermsControl.vue?vue&type=template&id=b43005f2&scoped=true&"
import script from "./TermsControl.vue?vue&type=script&lang=js&"
export * from "./TermsControl.vue?vue&type=script&lang=js&"
import style0 from "./TermsControl.vue?vue&type=style&index=0&id=b43005f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43005f2",
  null
  
)

export default component.exports